// history.js — ดึง "ประวัติการแก้ไข" (taction_log) ล่วงหน้าก่อนเปิด dialog
//
// กติกา UI ของระบบ (เจ้าของสั่ง 2026-08-22, เขียนไว้ใน CLAUDE.md ใต้ Dialog Standard):
// ทุกอย่างที่จะแสดงใน dialog ต้องโหลดเสร็จก่อน dialog โผล่ — ไม่ใช่เปิดแล้วค่อยเติม
// EditHistoryTimeline ยิงเองตอน mount ได้ แต่ถ้าพ่อแม่ส่ง prop `preloaded` มาก็จะข้ามการยิงนั้น
import axios from 'axios';

// คืน array ของ entry ดิบจาก /getEditHistory (ยังไม่ shape — component จัดรูปเอง)
// ไม่ throw: ดึงไม่ได้ → คืน null แล้ว component จะยิงเองตามเดิม (ไทม์ไลน์ห้ามทำให้ dialog เปิดไม่ได้)
export async function fetchEditHistory(baseURL, token, kind, refid) {
  if (!kind || refid === null || refid === undefined || refid === '') return null;
  try {
    const response = await axios.post(`${baseURL}/getEditHistory`, { kind, refid },
      { headers: { Authorization: 'Bearer ' + token } });
    return (response.data && response.data.success) ? (response.data.history || []) : null;
  } catch (error) {
    return null;
  }
}

// ไทม์ไลน์การใช้คอร์ส (/getCourseUsageTimeline) — คู่ของ CourseUsageTimeline.vue · ไม่ throw เหมือนกัน
export async function fetchCourseUsage(baseURL, token, courserefer) {
  if (!courserefer) return null;
  try {
    const response = await axios.get(`${baseURL}/getCourseUsageTimeline/${encodeURIComponent(courserefer)}`,
      { headers: { Authorization: 'Bearer ' + token } });
    return (response.data && response.data.success) ? (response.data.events || []) : null;
  } catch (error) {
    return null;
  }
}

export default { fetchEditHistory, fetchCourseUsage };
